import axios from "axios";
import {store} from "../store";

export const getUrl = () => {
   const url = window.location.host.split('.')
   return (url[0].includes('localhost')) ? 'https://spring_deliveries_api.test' : 'https://apientregas.spring.com.co'
}

/*
 * Instancia con el servicio principal del backend
 */
const springApi = (contentType = 'application/json; charset=UTF-8') => {
   const state = store.getState();
   const authToken = state.auth.token;

   let domain = getUrl()

   return axios.create({
      baseURL: `${domain}/api`,
      timeout: 10000,
      headers: {
         Authorization: `Bearer ${authToken}`,
         "Content-Type": contentType,
      }
   });
};

export default springApi;
